import React from "react";
import Tooltip from "../../Tooltip";
import Button from "../../../form/Button";
import { t } from "i18next";

const QuestionItem = ({
  data,
  draggedOverIndex,
  index,
  handleDragLeave = () => {},
  handleDragOver = () => {},
  handleDragEnter = () => {},
  handleDrop = () => {},
  handleDragStart = () => {},
  handleDragEnd = () => {},
  onEdit = () => {},
  onDelete = () => {},
  draggedItem,
  readOnly,
  selectedLang,
}) => {
  return (
    <div
      {...(!readOnly && {
        onDragOver: (e) => handleDragOver(e),
        onDragEnter: (e) => handleDragEnter(e, index),
        onDragLeave: (e) => handleDragLeave(e),
        onDrop: (e) => handleDrop(e, index),
      })}
      className={`relative w-full h-12 px-4 pr-12 text-sm font-medium flex items-center justify-between rounded-md border transition-all
                    ${
                      data?.disabled
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-white border-gray-300 text-deep-purple hover:shadow-sm"
                    }
                    ${
                      draggedOverIndex === index &&
                      !data?.disabled &&
                      !data?.isGlobal
                        ? "border-blue-400 bg-blue-50"
                        : ""
                    }
                    ${draggedItem?.index === index ? "opacity-50" : ""}`}
    >
      {/* Drag Handle */}
      {!readOnly && (
        <div
          className={`flex items-center mr-3 ${
            data?.disabled ? "cursor-not-allowed opacity-50" : "cursor-move"
          }`}
          draggable={!data?.disabled}
          onDragStart={(e) => handleDragStart(e, data, index)}
          onDragEnd={handleDragEnd}
        >
          <i className="fa-solid fa-grip-vertical text-gray-400"></i>
        </div>
      )}

      <span className="flex-1">
        {data?.label}
        {data?.required && !data?.disabled && (
          <span className="text-red-500"> *</span>
        )}
        {data?.disabled && (
          <span className="ml-1 text-xs text-gray-400">({t("Disabled")})</span>
        )}
      </span>

      {!readOnly && (
        <div className="absolute right-3 flex items-center gap-2">
          {data?.editable && !data?.disabled && (
            <Tooltip message="Edit this question" position="top">
              <Button
                buttonIcon="fa-regular fa-edit"
                buttonClasses="text-gray-700 hover:text-black bg-transparent px-0"
                buttonFunction={() => onEdit(data)}
              />
            </Tooltip>
          )}

          {data?.deletable && !data?.disabled && (
            <Tooltip message="Delete this question" position="top">
              <Button
                buttonIcon="fa-regular fa-trash"
                buttonClasses="text-red-500 hover:text-red-700 bg-transparent px-0"
                buttonFunction={() => onDelete(data)}
              />
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
};

export default QuestionItem;
